// angular
import { Component, input } from '@angular/core';
// components
import { SectionTabsComponent } from '@app/core/components/section-tabs/section-tabs.component';
// interfaces
import { ISectionTab } from '@app/core/shared/interfaces/section-tab.interface';

@Component({
  selector: 'pwj-product-navigation-tabs',
  standalone: true,
  imports: [SectionTabsComponent],
  templateUrl: './product-navigation-tabs.component.html',
  styleUrl: './product-navigation-tabs.component.scss',
})
export class ProductNavigationTabsComponent {
  // inputs
  tabsData = input.required<ISectionTab[]>();
}
